import React__default, { createContext, forwardRef, useContext } from "react";
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
var dist = {};
var __assign = commonjsGlobal && commonjsGlobal.__assign || function() {
  __assign = Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = commonjsGlobal && commonjsGlobal.__read || function(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m)
    return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done)
      ar.push(r.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r && !r.done && (m = i["return"]))
        m.call(i);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
};
var __spreadArray = commonjsGlobal && commonjsGlobal.__spreadArray || function(to, from, pack) {
  if (pack || arguments.length === 2)
    for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
        if (!ar)
          ar = Array.prototype.slice.call(from, 0, i);
        ar[i] = from[i];
      }
    }
  return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(dist, "__esModule", { value: true });
var isObject = function(obj) {
  if (typeof obj === "object" && obj !== null) {
    if (typeof Object.getPrototypeOf === "function") {
      var prototype = Object.getPrototypeOf(obj);
      return prototype === Object.prototype || prototype === null;
    }
    return Object.prototype.toString.call(obj) === "[object Object]";
  }
  return false;
};
var merge = function() {
  var objects = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    objects[_i] = arguments[_i];
  }
  return objects.reduce(function(result, current) {
    if (Array.isArray(current)) {
      throw new TypeError("Arguments provided to ts-deepmerge must be objects, not arrays.");
    }
    Object.keys(current).forEach(function(key) {
      if (["__proto__", "constructor", "prototype"].includes(key)) {
        return;
      }
      if (Array.isArray(result[key]) && Array.isArray(current[key])) {
        result[key] = merge.options.mergeArrays ? Array.from(new Set(result[key].concat(current[key]))) : current[key];
      } else if (isObject(result[key]) && isObject(current[key])) {
        result[key] = merge(result[key], current[key]);
      } else {
        result[key] = current[key];
      }
    });
    return result;
  }, {});
};
var defaultOptions = {
  mergeArrays: true
};
merge.options = defaultOptions;
merge.withOptions = function(options) {
  var objects = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    objects[_i - 1] = arguments[_i];
  }
  merge.options = __assign({ mergeArrays: true }, options);
  var result = merge.apply(void 0, __spreadArray([], __read(objects), false));
  merge.options = defaultOptions;
  return result;
};
var _default = dist.default = merge;
const GlobalContext = createContext({});
const UKCProvider = ({ children, value }) => {
  return /* @__PURE__ */ React__default.createElement(GlobalContext.Provider, { value }, children);
};
const connectGlobalPropsContext = (Component, componentName) => {
  const globalContextFunction = forwardRef((props, ref) => {
    const value = useContext(GlobalContext);
    const componentContext = value == null ? void 0 : value[componentName];
    let mergedProps = {};
    if (typeof componentContext === "function") {
      mergedProps = componentContext(props);
    } else {
      mergedProps = _default(componentContext || {}, props);
    }
    return /* @__PURE__ */ React__default.createElement(Component, { ...mergedProps, ref });
  });
  globalContextFunction.displayName = Component.displayName;
  return globalContextFunction;
};
const globalContext = { UKCProvider, connectGlobalPropsContext };
const globalContext$1 = globalContext;
export {
  globalContext$1 as g
};
//# sourceMappingURL=global-context.js.map
